// 统计汇总
const StaSummaryMessage = () => import('../pages/statistics/StaSummaryMessage.vue');
const StaSumCollectRecord = () => import('../pages/statistics/StaSumCollectRecord.vue');
// const StaSumCollectRecordDetail = () => import('../pages/statistics/StaSumCollectRecordDetail.vue');
const StaRefundRecord = () => import('../pages/statistics/StaRefundRecord.vue');
// const StaRefundRecordDetail = () => import('../pages/statistics/StaRefundRecordDetail.vue');
const StaArrears = () => import('../pages/statistics/StaArrears.vue');
// const StaArrearsDetail = () => import('../pages/statistics/StaArrearsDetail.vue');
const StaMustRefunds = () => import('../pages/statistics/StaMustRefunds.vue');
// const StaMustRefundsDetail = () => import('../pages/statistics/StaMustRefundsDetail.vue');
const StaAccountReceivable = () => import('../pages/statistics/StaAccountReceivable.vue');
const StaAccChildCharge = () => import('../pages/statistics/StaAccChildCharge.vue');
const StaAccChildGrade = () => import('../pages/statistics/StaAccChildGrade.vue');
const StaAccChildDetailed = () => import('../pages/statistics/StaAccChildDetailed.vue');
const StaAccChildFaculty = () => import('../pages/statistics/StaAccChildFaculty.vue');
const StaChargeType = () => import('../pages/statistics/StaChargeType.vue');
const StaChargeMan = () => import('../pages/statistics/StaChargeMan.vue');
const StaChargeWay = () => import('../pages/statistics/StaChargeWay.vue');
const NewWindowDetail = () => import('../pages/statistics/NewWindowDetail.vue');
const StaChargeCondition = () => import('../pages/statistics/StaChargeCondition.vue');// 收费情况统计表
const StuCollectionDetail = () => import('../pages/statistics/StuCollectionDetail.vue');// 学生年度收款明细表
const feeDetailReceivable = () => import('../pages/statistics/feeDetailReceivable.vue');// 收费项交易明细
const collectionDetail = () => import('../pages/statistics/collectionDetail.vue');// 收款明细
const refundDetail = () => import('../pages/statistics/refundDetail.vue');
const Xsjfqkb = () => import('../pages/statistics/Xsjfqkb.vue'); // 学生缴费情况表
const CommonReport = () => import('../pages/statistics/CommonReport.vue');
export default [{
	path: '/StaSummaryMessage',
	name: 'StaSummaryMessage',
	component: StaSummaryMessage,
}, {
	path: '/StaArrears',
	name: 'StaArrears',
	component: StaArrears,
}, {
	path: '/StaMustRefunds',
	name: 'StaMustRefunds',
	component: StaMustRefunds,
}, {
	path: '/StaChargeWay',
	name: 'StaChargeWay',
	component: StaChargeWay,
}, {
	path: '/StaSumCollectRecord',
	name: 'StaSumCollectRecord',
	component: StaSumCollectRecord,
}, {
	path: '/StaRefundRecord',
	name: 'StaRefundRecord',
	component: StaRefundRecord,
}, {
	path: '/StaChargeType',
	name: 'StaChargeType',
	component: StaChargeType,
}, {
	path: '/StaChargeMan',
	name: 'StaChargeMan',
	component: StaChargeMan,
}, {
	path: '/StaAccountReceivable',
	name: 'StaAccountReceivable',
	component: StaAccountReceivable,
	children: [
		{ // 收费项统计
			path: '/StaAccChildCharge',
			name: 'StaAccChildCharge',
			component: StaAccChildCharge,
			meta: { parent: '/StaAccountReceivable' },
		},
		{ // 年级统计
			path: '/StaAccChildGrade',
			name: 'StaAccChildGrade',
			meta: { parent: '/StaAccountReceivable' },
			component: StaAccChildGrade,
		},
		{ // 年级统计
			path: '/StaAccChildFaculty',
			name: 'StaAccChildFaculty',
			meta: { parent: '/StaAccountReceivable' },
			component: StaAccChildFaculty,
		},
	],
	},
	{
		path: '/feeDetailReceivable',
		name: 'feeDetailReceivable',
		component: feeDetailReceivable,
		children: [
			{ // 收款明细
				path: '/collectionDetail',
				name: 'collectionDetail',
				component: collectionDetail,
				meta: { parent: '/collectionDetail' },
			},
			{ // 退款明细
				path: '/refundDetail',
				name: 'refundDetail',
				meta: { parent: '/refundDetail' },
				component: refundDetail,
			},
		],
	},
	{
	path: '/StaAccChildDetailed/:filter',
	name: 'StaAccChildDetailed',
	component: StaAccChildDetailed,
}, {
	path: '/NewWindowDetail',
	name: 'NewWindowDetail',
	component: NewWindowDetail,
},
{ // 收费情况统计表
	path: '/StaChargeCondition',
	name: 'StaChargeCondition',
	component: StaChargeCondition,
	},
{
	// 学生年度收款明细表
	path: '/StuCollectionDetail',
	name: '/StuCollectionDetail',
	component: StuCollectionDetail,
}, {
	path: '/Xsjfqkb',
	component: Xsjfqkb,
	name: 'Xsjfqkb',
}, {
	path: '/CommonReport',
	component: CommonReport,
	name: 'CommonReport',
}];

